import RowPaymentApp from './RowPaymentApp';

export default RowPaymentApp;
